import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Controller } from 'swiper/modules';
import YouTubeIframeLoader from 'youtube-iframe';
import '../../scss/modules/_lightbox.scss';

class Lightbox extends Component {
  constructor(el) {
    super(el);
    this.videoId = this.el.dataset.videoId || '';
    this.lightBoxSwiper = {};
    this.player = null;
    this.initSwiper();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      swiperContainer: this.el.querySelector('.swiper'),
      swiperWrapper: this.el.querySelector('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll('.swiper-slide'),
      pagination: this.el.querySelector('.swiper-pagination'),
      closeBtn: this.el.querySelector('.close'),
      videoContainer: this.el.querySelector('.video-container'),
      shareBtn: this.el.querySelector('.lightbox__share-btn'),
      toastElement: document.querySelector('#toast'),
      boatHeaderTitle: document.querySelector('.boat-header__title')
    };

    this.initYoutubePlayer();
  }

  addListeners() {
    this.dom.closeBtn.addEventListener('click', () => {
      this.dom.el.classList.remove('show');
      if (this.player?.pauseVideo) {
        this.player.pauseVideo();
      }
    });
    window.addEventListener('mediaGallerySlideChange', e =>
      this.handleGallerySlideChange(e)
    );
    this.dom.shareBtn.addEventListener('click', this.handleShareClick.bind(this));
  }

  handleShareClick() {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: this.dom.boatHeaderTitle?.textContent || '',
          url: window.location.href
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(window.location.href);
      this.dom.toastElement?.classList.add('show');
      setTimeout(() => {
        this.dom.toastElement?.classList.remove('show');
      }, 3000);
    }
  }

  initYoutubePlayer() {
    YouTubeIframeLoader.load(YT => {
      this.player = new YT.Player(this.dom.videoContainer, {
        width: '100%',
        height: '100%',
        videoId: this.videoId
      });
    });
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard, Pagination, Controller]);
    const hash = window.location.hash.substring(1);
    const [mediaType, slideIndex] = hash.split(',');
    const initialSlide = mediaType?.includes('image') && slideIndex ? parseInt(slideIndex, 10) - 1 : 0;

    this.lightBoxSwiper = new Swiper(this.dom.swiperContainer, {
      pagination: {
        el: this.dom.pagination,
        type: 'fraction'
      },
      initialSlide,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      on: {
        realIndexChange: swiper => {
          if (this.el.classList.contains('show')) {
            window.dispatchEvent(
              new CustomEvent('lightboxSlideChange', { detail: swiper.realIndex })
            );
          }
        }
      }
    });
  }

  handleGallerySlideChange(e) {
    if (this.lightBoxSwiper?.slideToLoop) {
      this.lightBoxSwiper.slideToLoop(e.detail);
    }
  }
}

export default Lightbox;